import objectPath from 'object-path'
import { badgeElement } from '../system/menu/formElements/data/element'
import { getDataValue } from '../element/table/Render'
import { getExternalRequest, getServiceRequest, setApi } from './Api'
import useAuth from 'hooks/useAuth'
import { getFormGroup, getFormGroupOption } from './FormGroup'

export const CONDITION_GROUP = {
  header: 0,
  body: 1,
  footer: 2,
  condition: 3,
  pathParam: 4,
  queryParam: 5,
  datasources: 6,
  provider: 8,
  response: 9,
  user: 10,
  perspective: 11,
  layout: 12,
  widget: 13,
  formGroup: 14,
  localStorage: 15,
}

export const CONDITION_GROUP_OPTION = Object.keys(CONDITION_GROUP).map(
  (value) => {
    let groupIndex = CONDITION_GROUP[value]
    let camelCase = value.replace(/([a-z0-9])([A-Z])/g, '$1 $2').split(' ')
    let label = ''
    camelCase.forEach((word) => {
      label = label + word.charAt(0).toUpperCase() + word.slice(1) + ' '
    })

    return { label, value, groupIndex }
  },
)

const UI_HAS_OPTIONS = [
  'select',
  'autocomplete',
  'checkboxGroup',
  'tab',
  'panelGroup',
]

const findUiSchema = (elements, indices) => {
  let newElements = indices.reduce(
    (o, i) => objectPath.get(o, ['elements', i]),
    { elements },
  )
  return newElements
}

const findUischemaIndex = (currentKey, mapKey, elements) => {
  let indexList = []
  let newElements = elements
  if (mapKey) {
    let listKey = mapKey.split('.')
    listKey.forEach((key, i, array) => {
      let index = newElements.findIndex((element) => element.key === key)
      let element = objectPath.get(newElements, [index, 'elements'])
      if (element) {
        newElements = element
        indexList = [...indexList, index]
      }
      if (key === currentKey) {
        array.length = i + 1
      }
    })
    return indexList
  }
  return []
}

const getCurrentUi = (key, schema, uischema) => {
  let mapKey = schema.mapKey[key]
  let elements = uischema.elements
  let indices = findUischemaIndex(key, mapKey, elements)
  let currentElement = findUiSchema(elements, indices)
  return currentElement
}

export const createWidgetElementOption = (designContext) => {
  let { widgetDesign = {}, jsonForm } = designContext
  let mapTag = jsonForm.schema.mapTag
  let formWidgetKey = Object.keys(mapTag).filter(
    (key) => mapTag[key] === 'widget',
  )
  let formWidgetUi = []
  formWidgetKey.forEach((key) => {
    let ui = getCurrentUi(key, jsonForm.schema, jsonForm.uischema)
    if (ui.key === key) {
      formWidgetUi.push(ui)
    }
  })
  let elements = []
  Object.values(widgetDesign).forEach((design) => {
    let { formWidgetName, formCode } = design
    let widgetUi = formWidgetUi.find(({ path }) => path === formCode) || {}
    let options = createInputOption(design, null, {
      formWidgetName,
      widgetUiName: widgetUi?.name,
    })
    elements = [...elements, ...options]
  })
  return elements
}

export const createWidgetOptions = (designContext, isSubField = false) => {
  let { jsonForm } = designContext
  let mapTag = jsonForm.schema.mapTag
  let mapWidgetUi = jsonForm.schema.mapWidget?.ui || {}
  let formWidgetUi = []
  if (isSubField === 'all') {
    Object.values(mapWidgetUi).forEach((ui) => {
      formWidgetUi.push(ui)
    })
    let formWidgetKey = Object.keys(mapTag).filter(
      (key) => mapTag[key] === 'widget',
    )
    formWidgetKey.forEach((key) => {
      let ui = getCurrentUi(key, jsonForm.schema, jsonForm.uischema)
      if (ui.key === key) {
        formWidgetUi.push(ui)
      }
    })
  } else if (isSubField == true) {
    Object.values(mapWidgetUi).forEach((ui) => {
      formWidgetUi.push(ui)
    })
  } else {
    let formWidgetKey = Object.keys(mapTag).filter(
      (key) => mapTag[key] === 'widget',
    )
    formWidgetKey.forEach((key) => {
      let ui = getCurrentUi(key, jsonForm.schema, jsonForm.uischema)
      if (ui.key === key) {
        formWidgetUi.push(ui)
      }
    })
  }
  return formWidgetUi
}

export const createTabFormOptions = (designContext) => {
  const { isUiChanged } = designContext
  let inputOptions = objectPath.get(isUiChanged, 'tabFormOption') || []
  return inputOptions
}

export const getUiFromTabForm = (uiKey, designContext) => {
  if (!designContext) return
  const { isUiChanged } = designContext
  const tabForm = objectPath.get(isUiChanged, ['tabForm'])
  if (!tabForm) return
  let tableUi
  Object.values(tabForm).forEach(({ jsonForm }) => {
    let { schema, uischema } = jsonForm
    let ui = getCurrentUi(uiKey, schema, uischema)
    if (ui.key === uiKey) {
      tableUi = ui
    }
  })
  return tableUi
}

export const createInputOption = (jsonForm, specificTag, widget, status) => {
  let {
    isReturnUi = false,
    isAddUi = false,
    isSkipMapFormData = false,
    isReturnData = false,
  } = status || {}
  let { formWidgetName } = widget || {}
  let mapKey = objectPath.get(jsonForm, 'schema.mapKey') || {}
  let mapTag = objectPath.get(jsonForm, 'schema.mapTag') || {}
  let mapName = objectPath.get(jsonForm, 'schema.mapName') || {}
  let mapFormData = objectPath.get(jsonForm, 'schema.mapFormData') || {}
  let mapDynamic = objectPath.get(jsonForm, 'schema.mapDynamic') || {}

  let orderMapNames = Object.keys(mapName)
  orderMapNames.sort((aKey, bKey) => mapName[aKey].localeCompare(mapName[bKey]))

  let filterForm =
    orderMapNames.filter((key) => {
      let ui = getCurrentUi(key, jsonForm.schema, jsonForm.uischema)
      let isDynamicUi =
        objectPath.get(mapDynamic, key) ||
        objectPath.get(mapTag, key) === 'dynamic'
      if (specificTag) {
        if (Array.isArray(specificTag)) {
          return specificTag.includes(ui.tagname)
        }
        if (mapTag[key]) {
          return mapTag[key] === specificTag
        }
      }
      if (isSkipMapFormData) {
        return true
      }
      if (objectPath.get(mapFormData, key) || isDynamicUi)
        return true
      return false
    }) || []

  let headerOptions = []
  let bodyOptions = []
  let footerOptions = []

  let uiOptions = []
  let dataOptions = []

  filterForm.map((key) => {
    let ui = getCurrentUi(key, jsonForm.schema, jsonForm.uischema)
    if (ui?.key !== key) return
    uiOptions.push(ui)
    let label = objectPath.get(mapName, key)
    let layout = label.split('.').shift()
    let fullKey = objectPath.get(mapKey, key)
    let keys = (fullKey && fullKey.split('.')) || []
    let fieldName = []
    let nameList = [layout]
    keys.shift()
    keys.forEach((key) => {
      let ui = getCurrentUi(key, jsonForm.schema, jsonForm.uischema)
      if (ui.tagname === 'checkboxGroup') {
        if (ui.key === key) {
          fieldName.push(ui.fieldName)
          nameList.push(ui.name)
        } else {
          let { options = [] } = ui
          let foundOption = options.find((option) => option.key === key)
          if (foundOption) {
            let { label, name } = foundOption
            fieldName.push(label)
            nameList.push(name)
          }
        }
      } else if (ui.fieldName) {
        fieldName.push(ui.fieldName)
        nameList.push(ui.name)
      } else {
        fieldName.push(ui.name)
        nameList.push(ui.name)
      }
    })
    let fullName = nameList.join('.')
    let shortName = ui.name
    fieldName = fieldName.join(' > ')
    let data = { key: key }
    let isWidget = formWidgetName ? true : false
    data = {
      ...data,
      label: `${fieldName} | ${shortName}`,
      name: fullName,
      value: shortName,
      fieldName: ui.fieldName,
      isDynamic:
        objectPath.get(mapDynamic, key) ||
        objectPath.get(mapTag, key) === 'dynamic',
      isInsideDynamic: ui.isInsideDynamic,
      dynamicName: shortName,
      isWidget: isWidget,
      fullKey: objectPath.get(mapKey, key),
      tagname: ui.tagname,
      ui,
    }
    dataOptions.push(data)
    if (isAddUi) {
      data = {
        ...data,
        ui,
      }
    }
    if (isWidget) {
      let { formCode } = jsonForm
      data = {
        ...data,
        ...widget,
        formCode,
      }
    }
    if (data) {
      if (layout === 'header') {
        headerOptions.push({
          ...data,
          groupType: layout,
          groupIndex: CONDITION_GROUP.header,
        })
      } else if (layout === 'body') {
        bodyOptions.push({
          ...data,
          groupType: layout,
          groupIndex: CONDITION_GROUP.body,
        })
      } else if (layout === 'footer') {
        footerOptions.push({
          ...data,
          groupType: layout,
          groupIndex: CONDITION_GROUP.footer,
        })
      }
    }

    if (ui.tagname === 'checkboxGroup') {
      let { options } = ui
      options.forEach((option) => {
        let data = {
          label: `${option.label} | ${option.name}`,
          key: option.key,
          name: fullName,
          value: option.name,
          fieldName: option.label,
          isDynamic: objectPath.get(mapDynamic, key),
          isInsideDynamic: ui.isInsideDynamic,
          dynamicName: option.name,
          fullKey: objectPath.get(mapKey, option.key),
          tagname: 'checkbox',
        }
        dataOptions.push(data)
        if (layout === 'header') {
          headerOptions.push({
            ...data,
            groupType: layout,
            groupIndex: CONDITION_GROUP.header,
          })
        } else if (layout === 'body') {
          bodyOptions.push({
            ...data,
            groupType: layout,
            groupIndex: CONDITION_GROUP.body,
          })
        } else if (layout === 'footer') {
          footerOptions.push({
            ...data,
            groupType: layout,
            groupIndex: CONDITION_GROUP.footer,
          })
        }
      })
    } else if (ui.tagname === 'checkboxInput') {
      if (ui?.input?.name) {
        let field = ui.input.field
        let shortName = ui.input.name
        let key = ui.input.key
        let label = fieldName.split(' > ')
        label.pop()
        label.push(field)
        label = label.join(' > ')
        let data = {
          label: `${label} | ${shortName}`,
          name: fullName,
          value: shortName,
          key,
          fieldName: ui.input.field,
          isDynamic: objectPath.get(mapDynamic, key),
          isInsideDynamic: ui.isInsideDynamic,
          dynamicName: shortName,
          isWidget: isWidget,
          fullKey: objectPath.get(mapKey, key),
          tagname: 'input',
        }
        dataOptions.push(data)
        if (layout === 'header') {
          headerOptions.push({
            ...data,
            groupType: layout,
            groupIndex: CONDITION_GROUP.header,
          })
        } else if (layout === 'body') {
          bodyOptions.push({
            ...data,
            groupType: layout,
            groupIndex: CONDITION_GROUP.body,
          })
        } else if (layout === 'footer') {
          footerOptions.push({
            ...data,
            groupType: layout,
            groupIndex: CONDITION_GROUP.footer,
          })
        }
      }
    }
  })
  if (isReturnData) {
    return dataOptions
  }
  if (isReturnUi) {
    return uiOptions
  }
  return [...headerOptions, ...bodyOptions, ...footerOptions]
}

export const createTabParamOption = (jsonForm) => {
  let tabOptions = createInputOption(jsonForm, 'tab', null, {
    isReturnUi: true,
  })
  let filterTabParam = []
  tabOptions.map(({ fieldName, key, param }) => {
    if (param) {
      param.forEach((item) => {
        let foundParam = filterTabParam.find((tabParam) => {
          return tabParam.name === item.name
        })
        if (!foundParam) {
          filterTabParam.push({
            tabKey: key,
            name: item.name,
            value: `${key}.${item.name}`,
            label: `${fieldName} | ${item.name}`,
          })
        }
      })
    }
  })
  return filterTabParam
}

export const createSearchOption = (jsonForm) => {
  let mapKey = objectPath.get(jsonForm, 'schema.mapKey') || {}
  let mapName = objectPath.get(jsonForm, 'schema.mapName') || {}
  let mapFormData = objectPath.get(jsonForm, 'schema.mapFormData') || {}

  let orderMapNames = Object.keys(mapName)
  orderMapNames.sort((aKey, bKey) => mapName[aKey].localeCompare(mapName[bKey]))

  let filterForm =
    orderMapNames.filter((key) => {
      return objectPath.get(mapFormData, key)
    }) || []

  let dataOptions = []

  filterForm.map((key) => {
    let ui = getCurrentUi(key, jsonForm.schema, jsonForm.uischema)
    if (ui?.key !== key) return
    let label = objectPath.get(mapName, key)
    let layout = label.split('.').shift()
    if (layout !== 'header') return
    let fullKey = objectPath.get(mapKey, key)
    let keys = (fullKey && fullKey.split('.')) || []
    let fieldName = []
    let nameList = [layout]

    keys.shift()
    keys.forEach((key) => {
      let ui = getCurrentUi(key, jsonForm.schema, jsonForm.uischema)
      if (ui.tagname === 'checkboxGroup') {
        if (ui.key === key) {
          fieldName.push(ui.fieldName)
          nameList.push(ui.name)
        } else {
          let { options = [] } = ui
          let foundOption = options.find((option) => option.key === key)
          if (foundOption) {
            let { label, name } = foundOption
            fieldName.push(label)
            nameList.push(name)
          }
        }
      } else if (ui.fieldName) {
        fieldName.push(ui.fieldName)
        nameList.push(ui.name)
      } else {
        fieldName.push(ui.name)
        nameList.push(ui.name)
      }
    })
    let fullName = nameList.join('.')
    let shortName = ui.name
    fieldName = fieldName.join(' > ')
    let data = { key: key }
    data = {
      ...data,
      label: `${fieldName} | ${shortName}`,
      name: fullName,
      value: shortName,
      fieldName: ui.fieldName,
      tagname: ui.tagname,
    }
    if (ui.tagname === 'checkboxGroup') {
      let { options } = ui
      options.forEach((option) => {
        let data = {
          label: `${option.label} | ${option.name}`,
          key: option.key,
          name: fullName,
          value: option.name,
          fieldName: option.label,
          tagname: 'checkbox',
        }
        dataOptions.push(data)
      })
    } else {
      dataOptions.push(data)
    }
  })

  return dataOptions
}

export const createContainerOption = (
  jsonForm,
  specificTag,
  widget,
  status,
) => {
  let { isReturnUi = false, isAddUi = false } = status || {}
  let { formWidgetName } = widget || {}
  let mapKey = objectPath.get(jsonForm, 'schema.mapKey') || {}
  let mapTag = objectPath.get(jsonForm, 'schema.mapTag') || {}
  let mapName = objectPath.get(jsonForm, 'schema.mapName') || {}
  let mapDynamic = objectPath.get(jsonForm, 'schema.mapDynamic') || {}

  let orderMapNames = Object.keys(mapName)
  orderMapNames.sort((aKey, bKey) => mapName[aKey].localeCompare(mapName[bKey]))

  let filterForm =
    orderMapNames.filter((key) => {
      let ui = getCurrentUi(key, jsonForm.schema, jsonForm.uischema)
      if (ui.uiType !== 'container') return false
      if (specificTag) {
        if (Array.isArray(specificTag)) {
          return specificTag.includes(ui.tagname)
        }
        if (mapTag[key]) {
          return mapTag[key] === specificTag
        }
      }
      return true
    }) || []

  let headerOptions = []
  let bodyOptions = []
  let footerOptions = []

  let uiOptions = []

  filterForm.map((key) => {
    let ui = getCurrentUi(key, jsonForm.schema, jsonForm.uischema)
    if (ui?.key !== key) return
    uiOptions.push(ui)
    let label = objectPath.get(mapName, key)
    let layout = label.split('.').shift()
    let fullKey = objectPath.get(mapKey, key)
    let keys = (fullKey && fullKey.split('.')) || []
    let fieldName = []
    let nameList = [layout]
    keys.shift()
    keys.forEach((key) => {
      let ui = getCurrentUi(key, jsonForm.schema, jsonForm.uischema)
      if (ui.tagname === 'checkboxGroup') {
        if (ui.key === key) {
          fieldName.push(ui.fieldName)
          nameList.push(ui.name)
        } else {
          let { options = [] } = ui
          let foundOption = options.find((option) => option.key === key)
          if (foundOption) {
            let { label, name } = foundOption
            fieldName.push(label)
            nameList.push(name)
          }
        }
      } else if (ui.fieldName) {
        fieldName.push(ui.fieldName)
        nameList.push(ui.name)
      } else {
        fieldName.push(ui.name)
        nameList.push(ui.name)
      }
    })
    let fullName = nameList.join('.')
    let shortName = ui.name
    fieldName = fieldName.join(' > ')
    let data = { key: key }
    let isWidget = formWidgetName ? true : false
    data = {
      ...data,
      label: `${fieldName} | ${shortName}`,
      name: fullName,
      value: shortName,
      fieldName: ui.fieldName,
      isDynamic: objectPath.get(mapDynamic, key),
      isInsideDynamic: ui.isInsideDynamic,
      dynamicName: shortName,
      isWidget: isWidget,
      fullKey: objectPath.get(mapKey, key),
      tagname: ui.tagname,
    }
    if (isAddUi) {
      data = {
        ...data,
        ui,
      }
    }
    if (isWidget) {
      let { formCode } = jsonForm
      data = {
        ...data,
        ...widget,
        formCode,
      }
    }
    if (data) {
      if (layout === 'header') {
        headerOptions.push({ ...data, groupIndex: CONDITION_GROUP.header })
      } else if (layout === 'body') {
        bodyOptions.push({ ...data, groupIndex: CONDITION_GROUP.body })
      } else if (layout === 'footer') {
        footerOptions.push({ ...data, groupIndex: CONDITION_GROUP.footer })
      }
    }
  })
  if (isReturnUi) {
    return uiOptions
  }
  return [...headerOptions, ...bodyOptions, ...footerOptions]
}

export const createActiveTabOption = (jsonForm, specificTag) => {
  let tabs = createInputOption(jsonForm, specificTag, null, { isAddUi: true })
  let activeTabs = []
  tabs.forEach(({ ui }) => {
    let { elements } = ui
    elements.forEach((item) => {
      let data = {
        tabKey: ui.key,
        tabName: ui.name,
        panelKey: item.key,
        panelName: item.name,
        label: `${ui.fieldName} > ${item.fieldName}`,
        value: item.key,
      }
      activeTabs.push(data)
    })
  })
  return activeTabs
}

export const createDynamicPanelOption = (jsonForm, condition) => {
  let dynamicKey = condition?.dynamicKey
  let mapDynamic = objectPath.get(jsonForm, 'schema.mapDynamic') || {}
  let mapKey = objectPath.get(jsonForm, 'schema.mapKey') || {}
  let options = []
  if (dynamicKey) {
    let dynamicUi = getCurrentUi(dynamicKey, jsonForm.schema, jsonForm.uischema)
    Object.keys(mapKey).forEach((key) => {
      let fullKey = mapKey[key]
      fullKey = fullKey.split('.')
      if (fullKey.includes(dynamicKey)) {
        let itemUi = getCurrentUi(key, jsonForm.schema, jsonForm.uischema)
        if (dynamicKey === itemUi.key) return
        if (itemUi.type !== 'Control') {
          if (itemUi.tagname !== 'dynamic') return
        }
        let data = {
          label: `${dynamicUi.fieldName} > ${
            itemUi.fieldName || itemUi.name
          } | ${itemUi.name}`,
          name: dynamicUi.name,
          key: itemUi.key,
          value: itemUi.name,
          isDynamic: true,
          fieldName: itemUi.fieldName,
          dynamicName: dynamicUi.name,
          dynamicKey: dynamicUi.key,
          dynamicFieldName: dynamicUi.fieldName,
        }
        options.push(data)
      }
    })
  } else {
    Object.keys(mapDynamic).forEach((dynamicKey) => {
      let dynamicUi = getCurrentUi(
        dynamicKey,
        jsonForm.schema,
        jsonForm.uischema,
      )
      Object.keys(mapKey).forEach((key) => {
        let fullKey = mapKey[key]
        fullKey = fullKey.split('.')
        if (fullKey.includes(dynamicKey)) {
          let itemUi = getCurrentUi(key, jsonForm.schema, jsonForm.uischema)
          if (dynamicKey === itemUi.key) return
          if (itemUi.type !== 'Control') return
          let data = {
            label: `${dynamicUi.fieldName} > ${
              itemUi.fieldName || itemUi.name
            } | ${itemUi.name}`,
            name: dynamicUi.name,
            key: itemUi.key,
            value: itemUi.name,
            isDynamic: true,
            fieldName: itemUi.fieldName,
            dynamicName: dynamicUi.name,
            dynamicKey: dynamicUi.key,
            dynamicFieldName: dynamicUi.fieldName,
          }
          options.push(data)
        }
      })
    })
  }

  return options
}

export const createElementOption = (jsonForm, specificTag) => {
  let mapKey = objectPath.get(jsonForm, 'schema.mapKey') || {}
  let mapName = objectPath.get(jsonForm, 'schema.mapName') || {}
  let mapWidgetName = objectPath.get(jsonForm, 'schema.mapWidget.name') || {}
  let mapWidgetDynamic =
    objectPath.get(jsonForm, 'schema.mapWidget.dynamic') || {}
  let mapDynamic = objectPath.get(jsonForm, 'schema.mapDynamic') || {}
  let options = []
  let dynamicElements = []

  Object.keys(mapDynamic).forEach((key) => {
    let ui = getCurrentUi(key, jsonForm.schema, jsonForm.uischema)
    let label = objectPath.get(mapName, key)
    let elements = objectPath.get(ui, 'elements.0.elements') || []
    options.push({
      key: key,
      value: ui.name,
      label: label,
      isDynamic: true,
      dynamicName: ui.name,
    })
    dynamicElements.push({
      key: ui.key,
      dynamicKey: label,
    })
    dynamicElements = dynamicElements.concat(elements)
  })

  let allNames = { ...mapName, ...mapWidgetName }
  let orderMapNames = Object.keys(allNames)
  orderMapNames.sort((aKey, bKey) =>
    allNames[aKey].localeCompare(allNames[bKey]),
  )

  let headerOptions = []
  let bodyOptions = []
  let footerOptions = []

  orderMapNames.map((key) => {
    let ui = getCurrentUi(key, jsonForm.schema, jsonForm.uischema)
    if (specificTag) {
      if (!specificTag.includes(ui.tagname)) return
    }
    let { tagname } = ui
    let includeUi = UI_HAS_OPTIONS.includes(tagname)
    if (!includeUi) return

    let label =
      objectPath.get(mapName, key) || objectPath.get(mapWidgetName, key)
    let layout = label.split('.').shift()
    let fullKey = objectPath.get(mapKey, key)
    let keys = (fullKey && fullKey.split('.')) || []
    let fieldName = []
    let nameList = [layout]
    keys.shift()
    keys.forEach((key) => {
      let ui = getCurrentUi(key, jsonForm.schema, jsonForm.uischema)
      if (ui.tagname === 'checkboxGroup') {
        if (ui.key === key) {
          fieldName.push(ui.fieldName)
          nameList.push(ui.name)
        } else {
          let { options = [] } = ui
          let foundOption = options.find((option) => option.key === key)
          if (foundOption) {
            let { label, name } = foundOption
            fieldName.push(label)
            nameList.push(name)
          }
        }
      } else if (ui.fieldName) {
        fieldName.push(ui.fieldName)
        nameList.push(ui.name)
      }
    })
    let fullName = nameList.join('.')
    let shortName = fullName.split('.').pop()
    fieldName = fieldName.join(' > ')

    let data = {
      label: `${fieldName} | ${shortName}`,
      name: fullName,
      key: key,
      value: shortName,
      isDynamic:
        objectPath.get(mapDynamic, key) ||
        objectPath.get(mapWidgetDynamic, key),
      dynamicName: shortName,
    }

    if (layout === 'header') {
      headerOptions.push({ ...data, groupIndex: CONDITION_GROUP.header })
    } else if (layout === 'body') {
      bodyOptions.push({ ...data, groupIndex: CONDITION_GROUP.body })
    } else if (layout === 'footer') {
      footerOptions.push({ ...data, groupIndex: CONDITION_GROUP.footer })
    }
  })

  return [...headerOptions, ...bodyOptions, ...footerOptions]
}

export const createAllField = (jsonForm) => {
  let mapKey = objectPath.get(jsonForm, 'schema.mapKey') || {}
  let mapName = objectPath.get(jsonForm, 'schema.mapName') || {}
  let mapDynamic = objectPath.get(jsonForm, 'schema.mapDynamic') || {}
  let uiShowHide = {}

  const createItem = (ui = {}, parent = {}) => {
    let key = ui.key
    if (key) {
      objectPath.set(uiShowHide, key, ui.isShowUi)
    }

    let fullKey = objectPath.get(mapKey, key) || parent.fullKey || key || ''
    let name = objectPath.get(mapName, key)
    if (!name) {
      let nameList = parent.nameList || []
      name = [...nameList, ui.name || key].filter((item) => item).join('.')
    }

    let fieldNameList = parent.fieldNameList || []
    let currentFieldName = ui.fieldName || ui.name || key
    let fieldName = [...fieldNameList, currentFieldName]
      .filter((item) => item)
      .join(' > ')
    let shortName = ui.name || key
    let uiIndexList = [...(parent.uiIndexList || []), ui.index || 0]

    return {
      key,
      label: `${fieldName} | ${shortName}`,
      name,
      value: shortName,
      fieldName: currentFieldName,
      isDynamic: objectPath.get(mapDynamic, key),
      isInsideDynamic: ui.isInsideDynamic,
      dynamicName: shortName,
      fullKey,
      keyList: fullKey ? fullKey.split('.') : [],
      tagname: ui.tagname,
      isShowUi: ui.isShowUi,
      uiType: ui.uiType,
      uiIndex: ui.index,
      uiIndexList,
      children: [],
    }
  }

  const mapElement = (ui = {}, parent = {}) => {
    let item = createItem(ui, parent)
    let nextParent = {
      fullKey: item.fullKey,
      nameList: item.name ? item.name.split('.') : [],
      fieldNameList: [...(parent.fieldNameList || []), item.fieldName],
      uiIndexList: item.uiIndexList,
    }
    item.children = (ui.elements || []).map((element) =>
      mapElement(element, nextParent),
    )
    return item
  }

  let fieldList = (objectPath.get(jsonForm, 'uischema.elements') || []).map(
    (ui) => mapElement(ui),
  )

  return {
    fieldList,
    uiShowHide,
  }
}

export const createFieldConditionOption = (jsonForm) => {
  let mapName = objectPath.get(jsonForm, 'schema.mapName') || {}
  let options = []
  let mainElement = []

  Object.keys({ ...mapName }).forEach((key) => {
    let ui = getCurrentUi(key, jsonForm.schema, jsonForm.uischema)
    if (ui.uiType === 'layout') return
    let checkInMainElement = mainElement.find((itemKey) => itemKey === ui.key)
    if (checkInMainElement) {
      return
    }
    mainElement.push(key)
    let label = objectPath.get(mapName, key)
    let name = label.split('.').pop()
    options.push({
      key: key,
      value: name,
      label: label,
      fieldName: ui.fieldName,
    })
  })
  options.sort((a, b) => a.label.localeCompare(b.label))
  return options
}

export const createUrlParamOption = (jsonForm) => {
  let pathOptions = []
  let queryOptions = []
  let receivePathParams = objectPath.get(jsonForm, 'uischema.pathParams') || []
  let receiveQueryParams =
    objectPath.get(jsonForm, 'uischema.queryParams') || []

  receivePathParams.forEach(({ param }) => {
    let found = receivePathParams.find(({ key }) => key === param)
    if (found) return
    pathOptions.push({
      layout: 'urlParam',
      key: param,
      name: param,
      fieldName: param,
      shortName: param,
      label: param,
      value: param,
      tag: 'pathParam',
      groupIndex: CONDITION_GROUP.pathParam,
      isElement: false,
      groupType: 'pathParam',
    })
  })

  receiveQueryParams.forEach(({ param }) => {
    let found = receiveQueryParams.find(({ key }) => key === param)
    if (found) return
    queryOptions.push({
      layout: 'urlParam',
      key: param,
      name: param,
      fieldName: param,
      shortName: param,
      label: param,
      value: param,
      tag: 'queryParam',
      groupIndex: CONDITION_GROUP.queryParam,
      isElement: false,
      groupType: 'queryParam',
    })
  })

  return [
    {
      label: 'Path Params',
      groupType: 'pathParam',
      options: pathOptions,
    },
    {
      label: 'Query Params',
      groupType: 'queryParam',
      options: queryOptions,
    },
  ]
}

export const createLocalStorageOption = () => {
  let array = Object.keys(localStorage)
  let options = []
  array.forEach((param) => {
    options.push({
      layout: 'localStorage',
      key: param,
      name: param,
      fieldName: param,
      shortName: param,
      label: param,
      value: param,
      tag: 'localStorage',
      groupIndex: CONDITION_GROUP.localStorage,
      groupType: 'localStorage',
      isElement: false,
    })
  })

  return {
    label: 'Local Storage',
    groupType: 'localStorage',
    options: options,
  }
}

export const createConditionOption = (jsonForm) => {
  let designerPropsData = objectPath.get(jsonForm, 'designerPropsData')
  let receiveProps = objectPath.get(designerPropsData, 'receive')
  let conditionProps = objectPath.get(jsonForm, 'conditionProps')
  let filterConditions = []
  if (receiveProps) {
    receiveProps.forEach((item) => {
      if (!item) return
      let { prop, propType } = item
      if (propType === 'condition')
        filterConditions.push({
          layout: propType,
          key: prop,
          name: prop,
          fieldName: prop,
          shortName: prop,
          label: prop,
          value: prop,
          tag: 'condition',
          groupIndex: CONDITION_GROUP.condition,
          groupType: 'condition',
        })
    })
  }
  if (conditionProps) {
    conditionProps.forEach((item) => {
      if (!item) return
      let { formId, formName, props } = item
      if (props) {
        props.forEach(({ prop, propType }) => {
          filterConditions.push({
            layout: propType,
            key: prop,
            name: `${formId}.${prop}`,
            fieldName: prop,
            shortName: prop,
            label: [`Modal > ${formName}`, prop].join(' | '),
            value: prop,
            tag: 'condition',
            groupIndex: CONDITION_GROUP.condition,
            groupType: 'condition',
          })
        })
      }
    })
  }
  return {
    label: 'Condition',
    groupType: 'condition',
    options: filterConditions,
  }
}

export const createProviderLock = () => {
  let array = ['Patient']
  let options = []
  array.forEach((param) => {
    options.push({
      layout: 'provider',
      key: param,
      name: param,
      fieldName: param,
      shortName: param,
      label: param,
      value: param,
      tag: 'provider',
      groupIndex: CONDITION_GROUP.provider,
      isElement: false,
      isProvider: true,
      groupType: 'provider',
    })
  })
  return {
    label: 'Provider',
    groupType: 'provider',
    options: options,
  }
}

const createUserOption = () => {
  let options = []
  let arrayGroup = ['groups', 'permissions']
  let arrayUser = ['positionName', 'employeeRoleCode']
  arrayGroup.forEach((param) => {
    options.push({
      layout: 'user',
      key: param,
      name: param,
      fieldName: param,
      shortName: param,
      label: param,
      value: param,
      tag: 'user',
      groupIndex: CONDITION_GROUP.user,
      isElement: false,
      isArrayValue: true,
      groupType: 'user',
    })
  })
  arrayUser.forEach((param) => {
    options.push({
      layout: 'user',
      key: param,
      name: param,
      fieldName: param,
      shortName: param,
      label: param,
      value: param,
      tag: 'user',
      groupIndex: CONDITION_GROUP.user,
      isElement: false,
      isArrayValue: false,
      groupType: 'user',
    })
  })
  return {
    label: 'User',
    groupType: 'user',
    options: options,
  }
}

const createPerspectiveOption = () => {
  let options = [
    {
      layout: 'perspective',
      key: 'perspective',
      name: 'perspective',
      fieldName: 'Perspective',
      shortName: 'Perspective',
      label: 'Perspective',
      value: 'perspective',
      tag: 'user',
      groupIndex: CONDITION_GROUP.perspective,
      isPerspective: true,
      groupType: 'perspective',
    },
  ]

  return {
    label: 'Perspective',
    groupType: 'perspective',
    options: options,
  }
}

const createLayoutOption = () => {
  let array = [
    { label: 'ทั้งหมด', value: 'all' },
    { label: 'Header', value: 'header' },
    { label: 'Body', value: 'body' },
    { label: 'Footer', value: 'footer' },
  ]
  let options = []
  array.forEach(({ label, value }) => {
    options.push({
      layout: 'layout',
      key: value,
      name: value,
      fieldName: label,
      shortName: value,
      label: label,
      value: value,
      tag: 'layout',
      groupIndex: CONDITION_GROUP.layout,
      isElement: false,
      groupType: 'layout',
    })
  })
  return {
    label: 'Layout',
    groupType: 'layout',
    options: options,
  }
}

export const createWidgetField = (designContext) => {
  let { jsonForm, widgetDesign } = designContext
  let options = []
  if (jsonForm) {
    let mapTag = jsonForm.schema.mapTag
    let formWidgetKey = Object.keys(mapTag).filter(
      (key) => mapTag[key] === 'widget',
    )
    formWidgetKey.forEach((key) => {
      let ui = getCurrentUi(key, jsonForm.schema, jsonForm.uischema)
      if (ui.key === key) {
        let widgetCode = ui.path
        let jsonForm = objectPath.get(widgetDesign, widgetCode)
        let elementsUi = createInputOption(jsonForm, null, null)
        let fields = elementsUi.map((option) => {
          option = {
            ...option,
            label: `${ui.fieldName} : ${option.label}`,
            groupIndex: CONDITION_GROUP.widget,
            groupType: 'widget',
            widgetName: ui.name,
            widgetKey: ui.key,
          }
          return option
        })
        options = [...options, ...fields]
      }
    })
  }
  return {
    label: 'Widget',
    groupType: 'widget',
    options: options,
  }
}

export const createGroupFieldConditionOption = (
  jsonForm,
  designContext,
  condition = {},
) => {
  let {
    showAllOption = true,
    showOnlyFormData = false,
    showUrlOption = false,
    showOnlyProvider = false,
    showOnlyElement = false,
    showGroupElement = false,
    showOnlyData = false,
    specificTag,
    specificName,
    notIncludeName,
  } = condition

  let mapName = objectPath.get(jsonForm, 'schema.mapName') || {}
  let mapFormData = objectPath.get(jsonForm, 'schema.mapFormData') || {}
  let mapKey = objectPath.get(jsonForm, 'schema.mapKey') || {}
  let mapTag = objectPath.get(jsonForm, 'schema.mapTag') || {}
  let mapWidgetName = objectPath.get(jsonForm, 'schema.mapWidget.name') || {}
  let mapWidgetDynamic =
    objectPath.get(jsonForm, 'schema.mapWidget.dynamic') || {}
  let mapDynamic = objectPath.get(jsonForm, 'schema.mapDynamic') || {}
  let mainElement = []
  let headerOptions = []
  let bodyOptions = []
  let footerOptions = []
  let layoutOption = createLayoutOption()
  let urlParamsOption = createUrlParamOption(jsonForm)
  let providerLockOption = createProviderLock(jsonForm)
  let localStorageOption = createLocalStorageOption()
  let conditionOption = createConditionOption(jsonForm)
  let datasourcesOption = createDatasoureOptions(jsonForm)
  let apiConditionOption = createAllApiOption(jsonForm, false)
  let userOption = createUserOption()
  let widgetOptions = createWidgetField(designContext)
  let perspectiveOption = createPerspectiveOption()
  let tabFormOption = createTabFormOptions(designContext)
  let formGroupOption = getFormGroupOption(designContext)

  let orderMapKey = Object.keys(mapKey)
  orderMapKey.sort((aKey, bKey) => mapName[aKey].localeCompare(mapName[bKey]))
  orderMapKey.forEach((key) => {
    let ui = getCurrentUi(key, jsonForm.schema, jsonForm.uischema)
    if (specificTag) {
      if (!specificTag.includes(ui.tagname)) return
    }
    if (specificName) {
      let fillName = mapName[key]
      let nameList = fillName.split('.')
      if (!nameList.includes(specificName)) return
    }
    if (notIncludeName) {
      let fillName = mapName[key]
      let nameList = fillName.split('.')
      if (nameList.includes(notIncludeName)) return
    }
    if (ui.uiType === 'layout') return
    let checkInMainElement = mainElement.find((itemKey) => itemKey === ui.key)
    if (checkInMainElement) {
      return
    }
    if (showOnlyFormData && !mapFormData[key]) {
      return
    }
    if (showOnlyElement) {
      if (
        ui.uiType === 'container' &&
        !['dynamic', 'panelGroup'].includes(ui.tagname)
      ) {
        return
      }
      if (ui.uiType === 'element' && !mapFormData[key]) {
        return
      }
    }
    mainElement.push(key)
    let fullName = objectPath.get(mapName, key)
    let fullKey = objectPath.get(mapKey, key)
    let uitag = objectPath.get(mapTag, key)
    let value = ui.name
    let name = fullName.split('.')
    let keys = (fullKey && fullKey.split('.')) || []
    let layout = name.shift()
    let fieldName = []
    let dynamicKey = ''
    keys.shift()

    keys.forEach((key) => {
      let ui = getCurrentUi(key, jsonForm.schema, jsonForm.uischema)
      if (ui.fieldName) {
        fieldName.push(ui.fieldName)
      }
      if (objectPath.get(mapDynamic, key)) {
        dynamicKey = key
      }
    })

    let foundUi = getCurrentUi(key, jsonForm.schema, jsonForm.uischema)
    if (foundUi.key !== key) return
    let shortName = objectPath.get(fieldName, fieldName.length - 1)
    let isInDynamic = false
    if (dynamicKey) {
      isInDynamic = dynamicKey !== key
    }
    let optionData = {
      layout: layout,
      key: key,
      name: fullName,
      fieldName: fieldName.join(' > '),
      shortName: shortName,
      label: value,
      value: value,
      tag: uitag,
      isElement: true,
      groupType: layout,
      dynamicKey: dynamicKey,
    }
    if (layout === 'header') {
      headerOptions.push({ ...optionData, groupIndex: CONDITION_GROUP.header })
    } else if (layout === 'body') {
      bodyOptions.push({ ...optionData, groupIndex: CONDITION_GROUP.body })
    } else if (layout === 'footer') {
      footerOptions.push({ ...optionData, groupIndex: CONDITION_GROUP.footer })
    }
  })

  let allNames = { ...mapName, ...mapWidgetName }
  let orderMapNames = Object.keys(allNames)
  orderMapNames.sort((aKey, bKey) =>
    allNames[aKey].localeCompare(allNames[bKey]),
  )

  orderMapNames.map((key) => {
    let ui = getCurrentUi(key, jsonForm.schema, jsonForm.uischema)
    let { tagname } = ui
    let includeUi = UI_HAS_OPTIONS.includes(tagname)
    if (!includeUi) return

    let label =
      objectPath.get(mapName, key) || objectPath.get(mapWidgetName, key)
    let layout = label.split('.').shift()
    let fullKey = objectPath.get(mapKey, key)
    let keys = (fullKey && fullKey.split('.')) || []
    let fieldName = []
    let nameList = [layout]
    let dynamicKey = ''
    keys.shift()
    keys.forEach((key) => {
      let ui = getCurrentUi(key, jsonForm.schema, jsonForm.uischema)
      if (ui.tagname === 'checkboxGroup') {
        if (ui.key === key) {
          fieldName.push(ui.fieldName)
          nameList.push(ui.name)
        } else {
          let { options = [] } = ui
          let foundOption = options.find((option) => option.key === key)
          if (foundOption) {
            let { label, name } = foundOption
            fieldName.push(label)
            nameList.push(name)
          }
        }
      } else if (ui.fieldName) {
        fieldName.push(ui.fieldName)
        nameList.push(ui.name)
      }
      if (objectPath.get(mapDynamic, key)) {
        dynamicKey = key
      }
    })
    let fullName = nameList.join('.')
    let shortName = fullName.split('.').pop()
    fieldName = fieldName.join(' > ')
    let isCheckbox = tagname === 'checkboxGroup'

    let data = {
      label: `${fieldName} | ${shortName}`,
      name: fullName,
      key: key,
      value: shortName,
      isDynamic:
        objectPath.get(mapDynamic, key) ||
        objectPath.get(mapWidgetDynamic, key),
      dynamicName: shortName,
      dynamicKey: dynamicKey,
      isCheckbox,
    }

    if (ui.tagname === 'tab') {
      let { param = [] } = ui
      let filterParam = param.filter((item) => !item.isTabParam)
      filterParam.forEach(({ name, value }) => {
        let key = `${shortName}.${name}`
        let data = {
          label: `${fieldName} > ${shortName} | ${name}`,
          name: name,
          key: key,
          value: key,
          tabKey: ui.key,
          paramValue: value,
          isTabParam: true,
          layout,
        }
        if (layout === 'header') {
          let found = headerOptions.find((data) => data.key === key)
          if (found) return
          headerOptions.push({
            ...data,
            groupIndex: CONDITION_GROUP.header,
            groupType: layout,
          })
        } else if (layout === 'body') {
          let found = bodyOptions.find((data) => data.key === key)
          if (found) return
          bodyOptions.push({
            ...data,
            groupIndex: CONDITION_GROUP.body,
            groupType: layout,
          })
        } else if (layout === 'footer') {
          let found = footerOptions.find((data) => data.key === key)
          if (found) return
          footerOptions.push({
            ...data,
            groupIndex: CONDITION_GROUP.footer,
            groupType: layout,
          })
        }
      })
    }

    if (layout === 'header') {
      let found = headerOptions.find((data) => data.key === key)
      if (found) return
      headerOptions.push({
        ...data,
        groupIndex: CONDITION_GROUP.header,
      })
    } else if (layout === 'body') {
      let found = bodyOptions.find((data) => data.key === key)
      if (found) return
      bodyOptions.push({
        ...data,
        groupIndex: CONDITION_GROUP.body,
      })
    } else if (layout === 'footer') {
      let found = footerOptions.find((data) => data.key === key)
      if (found) return
      footerOptions.push({
        ...data,
        groupIndex: CONDITION_GROUP.footer,
      })
    }
  })

  let tabHeader = tabFormOption.filter(
    ({ groupType }) => groupType === 'header',
  )
  let tabBody = tabFormOption.filter(({ groupType }) => groupType === 'body')
  let tabFooter = tabFormOption.filter(
    ({ groupType }) => groupType === 'footer',
  )

  headerOptions = [...headerOptions, ...tabHeader]
  bodyOptions = [...bodyOptions, ...tabBody]
  footerOptions = [...footerOptions, ...tabFooter]

  let groupOptions = [
    layoutOption,
    {
      label: 'Header',
      groupType: 'header',
      options: headerOptions,
    },
    {
      label: 'Body',
      groupType: 'body',
      options: bodyOptions,
    },
    {
      label: 'Footer',
      groupType: 'footer',
      options: footerOptions,
    },
  ]

  if (showOnlyElement) {
    if (showGroupElement) {
      return groupOptions
    }
    return [...headerOptions, ...bodyOptions, ...footerOptions]
  }
  if (showOnlyFormData) {
    return groupOptions
  }
  if (showOnlyData) {
    return [
      ...groupOptions,
      ...urlParamsOption,
      {
        label: 'Datasources',
        groupType: 'datasources',
        options: datasourcesOption,
      },
      userOption,
    ]
  }
  if (showOnlyProvider) {
    return [providerLockOption]
  }

  if (showAllOption) {
    return [
      ...groupOptions,
      widgetOptions,
      conditionOption,
      ...urlParamsOption,
      {
        label: 'Datasources',
        groupType: 'datasources',
        options: datasourcesOption,
      },
      apiConditionOption,
      userOption,
      perspectiveOption,
      {
        label: 'Form Group',
        groupType: 'formGroup',
        options: formGroupOption,
      },
      localStorageOption,
    ]
  }
  if (showUrlOption) {
    return [...groupOptions, ...urlParamsOption]
  }

  return groupOptions
}

export const createDynamicOption = (jsonForm, uiName) => {
  let formData = objectPath.get(jsonForm, `formData.${uiName}.0`) || {}
  let options = []
  let filterForm = Object.keys(formData)
  filterForm.forEach((name) => {
    options.push({ value: name, label: name })
  })
  return options
}

export const createSystemOption = (jsonForm) => {
  let props = objectPath.get(jsonForm, 'designerPropsData.props') || []
  let filterSystem = props.filter((prop = {}) => prop?.systemType === 'system')
  let options = []
  filterSystem.forEach(({ systemName, systemKey }) => {
    options.push({ key: systemKey, value: systemName, label: systemName })
  })
  return options
}

export const createSystemRequestOption = (jsonForm) => {
  let props = objectPath.get(jsonForm, 'designerPropsData.receive') || []
  let receiveProps = props.filter((prop) => prop)
  let options = []
  receiveProps.forEach((mainProp = {}) => {
    let { prop, propType, jsonKey } = mainProp
    if (propType === 'system') {
      let key = jsonKey ? `${prop}.${jsonKey}` : prop
      options.push({ key: key, value: key, label: key })
    }
  })
  return options
}

export const createTableOptions = ({ ui }) => {
  let { tableColumn = [] } = ui
  let options = []
  tableColumn.forEach((value, index) => {
    options.push(value.field)
  })
  return options
}

export const createDatasourceRichText = (jsonForm) => {
  const datasources = objectPath.get(jsonForm, 'datasources') || {}
  let options = []

  Object.keys(datasources).forEach((dataKey) => {
    let { name = '', data = {}, key } = datasources[dataKey]
    let label =
      name === 'QueryParam' || name === 'PathParam' ? name : `API > ${name}`
    if (Object.keys(data).length > 0) {
      options.push({
        label: label,
        value: dataKey,
        data: data,
        key: key,
        isReceiveProp: false,
      })
    }
  })
  options.sort((a, b) => {
    if (a.label && b.label) {
      return a.label.localeCompare(b.label)
    }
    return -1
  })

  let props = objectPath.get(jsonForm, 'designerPropsData.receive') || []
  let receiveProps = props.filter(
    (prop) => prop.prop && prop.propType === 'datasource',
  )
  if (receiveProps) {
    receiveProps.forEach(({ prop }) => {
      options.push({
        label: prop,
        value: prop,
        data: {},
        key: [],
        isReceiveProp: true,
      })
    })
  }
  return options
}

export const createDatasoureOptions = (jsonForm, currentProp = {}) => {
  let { systemProp = {} } = currentProp
  const apiGroup = getAllApi(jsonForm)
  const datasources = objectPath.get(jsonForm, 'datasources') || {}
  let options = []
  Object.keys(datasources).forEach((dataKey) => {
    let { data = {}, name, isReceiveProp } = datasources[dataKey]
    let foundApi = apiGroup.find((api) => api.key === dataKey)
    let prefixLabel = foundApi ? 'API > ' : ''
    Object.keys(data).forEach((key) => {
      if (isReceiveProp) {
        options.push({
          label: `Receive Props | ${name}`,
          value: `receiveProps.${key}`,
          layout: 'datasources',
          key: key,
          name: name,
          fieldName: name,
          shortName: name,
          tag: 'datasources',
          groupIndex: CONDITION_GROUP.datasources,
          groupType: 'datasources',
          isElement: false,
        })
      } else {
        let isChecked = objectPath.get(data, key) || data[key]
        if (!isChecked) return
        options.push({
          label: `${prefixLabel}${name} | ${key}`,
          value: `${dataKey}.${key}`,
          layout: 'datasources',
          key: `${dataKey}.${key}`,
          name: name,
          fieldName: name,
          shortName: name,
          tag: 'datasources',
          groupIndex: CONDITION_GROUP.datasources,
          groupType: 'datasources',
          isElement: false,
        })
      }
    })
    if (dataKey === 'queryParam' || dataKey === 'pathParam') return
  })
  let props = objectPath.get(jsonForm, 'designerPropsData.receive') || []

  let receiveProps = props.filter((prop) => prop)
  if (receiveProps) {
    receiveProps.forEach((prop = {}) => {
      if (prop.propType === 'datasource') {
        let key = prop.jsonKey ? `${prop.prop}.${prop.jsonKey}` : prop.prop
        options.push({
          label: `Receive Props | ${key}`,
          value: `receiveProps.${key}`,
          layout: 'datasources',
          key: key,
          name: key,
          fieldName: key,
          shortName: key,
          tag: 'datasources',
          groupIndex: CONDITION_GROUP.datasources,
          groupType: 'datasources',
          isElement: false,
        })
      }
    })
  }

  options = options.sort((a, b) => a.label.localeCompare(b.label))
  if (systemProp?.propType === 'datasource') {
    let name = systemProp.prop
    let key = systemProp.propKey
    let newOptions = [
      {
        label: `Receive Props | ${name}`,
        value: `receiveProps.${key}`,
        layout: 'datasources',
        key: key,
        name: name,
        fieldName: name,
        shortName: name,
        tag: 'datasources',
        groupIndex: CONDITION_GROUP.datasources,
        groupType: 'datasources',
        isElement: false,
      },
    ]
    options = newOptions.concat(options)
  }

  return options
}

export const createResponseApiOptions = (uischema) => {
  const apiGroup = objectPath.get(uischema, 'action.crud.apiGroup')
  if (!apiGroup) return []
  let options = []
  apiGroup.forEach((api) => {
    let { apiName, mapResponse = [], mapResponseKey, mapResponseType } = api
    let apiKey = api.key
    mapResponse.forEach(({ response }) => {
      let valueKey = mapResponseKey ? `${mapResponseKey}.${response}` : response
      options.push({
        label: `${apiName} > ${response}`,
        value: `${apiKey}.${valueKey}`,
        responseName: response,
      })
    })
  })
  return options
}

export const createDatasetOptions = (jsonForm) => {
  const dataset = objectPath.get(jsonForm, 'dataset') || []
  let options = []
  dataset.forEach((data) => {
    options.push({
      label: data.name,
      value: data.key,
    })
  })
  return options
}

export const createApiResponseOptions = (ui, isGroup = true) => {
  let actionName = objectPath.get(ui, 'action.name')
  let apiGroup = objectPath.get(ui, `action.${actionName}.apiGroup`) || []
  let allOptions = []
  let groupOptions = []

  apiGroup.forEach(({ apiName, key, mapResponse, mapResponseKey }) => {
    if (mapResponse) {
      let options = [
        {
          label: mapResponseKey,
          value: mapResponseKey,
          apiName: apiName,
          apiKey: key,
          dataKey: mapResponseKey,
          isMainData: true,
        },
      ]
      let responseOptions = [
        {
          label: `${apiName} | ${mapResponseKey}`,
          value: mapResponseKey,
          key: mapResponseKey,
          apiName: apiName,
          apiKey: key,
          dataKey: mapResponseKey,
          isMainData: true,
          isResponse: true,
        },
      ]
      mapResponse.forEach(({ response }) => {
        options.push({
          label: `${mapResponseKey} > ${response}`,
          value: response,
          apiName: apiName,
          apiKey: key,
          dataKey: mapResponseKey,
          isMainData: false,
        })
        responseOptions.push({
          label: `${apiName} | ${mapResponseKey} > ${response}`,
          value: response,
          key: key,
          apiName: apiName,
          apiKey: key,
          dataKey: mapResponseKey,
          isMainData: false,
          isResponse: true,
        })
      })
      groupOptions.push({
        label: apiName,
        key: key,
        options: options,
      })
      allOptions = [...allOptions, ...responseOptions]
    }
  })

  if (isGroup) {
    return groupOptions
  }

  return allOptions
}

export const getApiCondition = (jsonForm) => {
  let apiGroup = jsonForm?.apiGroup || []
  let apiCondition = jsonForm?.apiCondition || []
  let filter = apiGroup.filter(({ condition = {} }) => condition?.condition)
  return [...filter, ...apiCondition]
}

export const getAllApi = (jsonForm) => {
  let apiGroup = jsonForm?.apiGroup || []
  let apiCondition = jsonForm?.apiCondition || []
  return [...apiGroup, ...apiCondition]
}

const createResponseOption = (api, valueKey, response) => {
  let { apiName, method = '' } = api
  let apiKey = api.key

  return {
    label: `${method.toUpperCase()}: ${apiName} > ${response}`,
    value: `${apiKey}.${valueKey}`,
    responseName: response,
    key: `${apiKey}.${valueKey}`,
    layout: 'response',
    name: `${apiKey}.${valueKey}`,
    tag: 'response',
    groupIndex: CONDITION_GROUP.response,
    groupType: 'response',
    isElement: false,
  }
}

export const createAllApiOption = (jsonForm, isMainResponse = true) => {
  let apiGroup = jsonForm?.apiGroup || []
  let apiCondition = jsonForm?.apiCondition || []
  let allGroup = [...apiGroup, ...apiCondition]
  let options = []

  allGroup.forEach((api) => {
    let {
      apiName,
      method = '',
      mapResponse,
      mapResponseKey,
      dataTable,
      dataKey,
    } = api
    let apiKey = api.key

    if (isMainResponse) {
      options.push({
        label: `${method.toUpperCase()}: ${apiName}`,
        value: apiKey,
        responseName: apiKey,
        key: apiKey,
        layout: 'response',
        name: apiKey,
        tag: 'response',
        groupIndex: CONDITION_GROUP.response,
        groupType: 'response',
        isElement: false,
      })
    } else {
      if (mapResponse) {
        mapResponse.forEach(({ response }) => {
          if (!response) return
          let valueKey = mapResponseKey
            ? `${mapResponseKey}.${response}`
            : response
          let option = createResponseOption(api, valueKey, response)
          options.push(option)
        })
      } else if (dataTable) {
        dataTable.forEach(({ response }) => {
          if (!response) return
          let valueKey = dataKey ? `${dataKey}.${response}` : response
          let option = createResponseOption(api, valueKey, response)
          options.push(option)
        })
      }
    }
  })

  return {
    label: 'Response',
    groupType: 'response',
    options: options,
  }
}

export const getOptionData = async ({ designContext, selectAction, data }) => {
  const { jsonForm, selectApiOption, setSelectApiOption } = designContext
  let { optionType } = selectAction
  let optionData = objectPath.get(selectAction, `${optionType}`) || {}
  let { service, endpoint, pathParams, queryParams, url, page, perPage } =
    optionData
  let action = {
    apiType: optionType,
    service: service,
    endpoint: endpoint,
    pathParams: pathParams,
    queryParams: queryParams,
    isOption: true,
    page,
    perPage,
    jsonForm,
  }
  if (objectPath.has(selectApiOption, url)) {
    let options = objectPath.get(selectApiOption, url)
    return options
  }
  let api = setApi(action, data)
  if (optionType === 'internal') {
    if (!service || !endpoint) return
    optionData = await getServiceRequest(
      api,
      optionData,
      selectAction,
      jsonForm.formData,
    )
  } else if (optionType === 'external') {
    if (!url) return
    optionData = await getExternalRequest(api, optionData, selectAction)
  }
  let { options = [] } = optionData
  objectPath.set(selectApiOption, url, options)
  setSelectApiOption(selectApiOption)
  return options
}

export const createLabel = (titleValue, options = []) => {
  if (
    Array.isArray(titleValue) &&
    titleValue.length > 0 &&
    Array.isArray(options)
  ) {
    options.map((option) => {
      let titleList = []
      let labelList = []
      let fontColor = ''
      let fontWeight = ''
      let isLockedSelect
      titleValue.forEach(
        ({ title, replaceValues, fontWeight: titleFontWeight }) => {
          let itemFontColor = ''
          let itemFontWeight = titleFontWeight || ''
          let subTitle = []
          title.forEach((title) => {
            let labelValue = title.value
            let hasValue = objectPath.has(option, title.value)
            if (hasValue) {
              labelValue = objectPath.get(option, title.value)
              if (replaceValues) {
                let foundReplace = replaceValues.find(({ value }) => {
                  let aValue = getDataValue(labelValue)
                  let bValue = getDataValue(value)
                  return aValue === bValue
                })
                if (foundReplace) {
                  let { replace } = foundReplace
                  labelValue = replace
                  itemFontColor = foundReplace.fontColor
                  itemFontWeight = foundReplace.fontWeight || titleFontWeight
                  isLockedSelect = foundReplace.isLockedSelect
                }
              }
            }
            subTitle.push(labelValue)
          })
          let label = subTitle.join('')
          fontColor = itemFontColor || fontColor
          fontWeight = itemFontWeight || fontWeight
          titleList.push(label)
          labelList.push({
            label,
            fontColor: itemFontColor,
            fontWeight: itemFontWeight,
          })
        },
      )
      let labelValue = titleList.join('')
      objectPath.set(option, '@isUseTitleValue', true)
      objectPath.set(option, '@label', labelValue)
      objectPath.set(option, '@labelList', labelList)
      objectPath.set(option, '@fontColor', fontColor)
      objectPath.set(option, '@fontWeight', fontWeight)
      if (isLockedSelect) {
        objectPath.set(option, 'isDisabled', fontColor)
      }
      return option
    })
    return options
  }
  return []
}

export const getFieldOptionByGroup = (setting, fields) => {
  let { groupType, groupIndex } = setting
  if (groupType === '' && groupIndex > -1) {
    let name = setting?.name
    groupType = name.split('.').shift()
  }
  if (groupType) {
    let found = fields.find((field) => groupType === field.groupType)
    if (found) {
      let { options = [] } = found
      return options
    }
  }
  if (groupIndex > -1) {
    return objectPath.get(fields, [groupIndex, 'options']) || []
  }
  return []
}

export const getValueFromOptions = (setting, fields, settingKey = null) => {
  if (!setting) return
  let options = getFieldOptionByGroup(setting, fields)
  if (!settingKey) {
    settingKey = setting.key
  }
  let found =
    options.find((option) => {
      let {
        key,
        groupType,
        groupIndex,
        widgetName,
        isFormComponent,
        formComponentKey,
        value,
      } = option
      if (isFormComponent) {
        if (setting.formComponentKey) {
          return (
            formComponentKey === setting.formComponentKey && key === settingKey
          )
        }
        return key === settingKey
      }
      if (widgetName) {
        return widgetName === setting.widgetName && key === settingKey
      }
      if (setting.groupType) {
        return groupType === setting.groupType && key === settingKey
      }
      if (setting.groupIndex > -1) {
        return groupIndex === setting.groupIndex && key === settingKey
      }
      if (setting.group > -1) {
        return groupIndex === setting.group && key === settingKey
      }
      return
    }) || null
  return found
}

export const getValueFromOption = (option) => {
  let { key, isFormComponent, formComponentKey } = option
  if (isFormComponent) {
    return `${formComponentKey}.${key}`
  }
  return key
}
